app.directive('fab', () => ({
  restrict : "E",
  replace: true,
  templateUrl: 'templates/directives/fab/fab.html'
}));